
import { Vue, Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import ProjectItem from '@/ui/components/components/ProjectItem.vue';
import { IProject } from '@/types/project.types';
import { filterProjects } from '@/utils/filterUtils';
import LynusPopup from '@/ui/components/components/LynusPopup.vue';
import {
  envTitle,
} from '@/utils/env';


/**
 * Component that represent all projects in Flex grid.
 * Used in Home page.
 */
@Component({
  components: {
    ProjectItem,
    LynusPopup
  },
})
export default class ProjectsListFlexGrid extends Vue {
  @State('projects') projectsState!: any;
  @Getter('projects/projects') projects!: IProject[];

  showPopup = false;
  localStorageKey = 'lynusNewAppPopup2'; 

  get filteredProjects() {
    const { projectFilters } = this.projectsState;
    return filterProjects(this.projects, projectFilters) ?? [];
  }

  handleClose() {
    this.showPopup = false;
  }

  mounted() {
    if (envTitle !== 'Lynus') return; // dont show this for white labels
    const lastShown = localStorage.getItem(this.localStorageKey);
    const threeDays = 3 * 24 * 60 * 60 * 1000; // Three days in milliseconds
    const now = new Date().getTime();

    // Check if the popup was never shown or if three days have passed since last shown
    if (!lastShown || now - parseInt(lastShown) > threeDays) {
      setTimeout(() => {
        this.showPopup = true;
        // Update localStorage with the current timestamp
        localStorage.setItem(this.localStorageKey, now.toString());
      }, 3000);
    }
  }
}
